import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ExternalRoute = () => {
  return  <Outlet />;
};

export default ExternalRoute;